export interface PeerConfig {
  readonly host: string;
  readonly port: number;
  readonly path: string;
  readonly secure: boolean;
  readonly iceServers: RTCIceServer[];
}

export function loadPeerConfig(env: ImportMetaEnv): PeerConfig {
  const port = parsePort(env.VITE_PEER_PORT ?? '443');
  return {
    host: env.VITE_PEER_HOST ?? '0.peerjs.com',
    port,
    path: env.VITE_PEER_PATH ?? '/',
    secure: env.VITE_PEER_SECURE !== 'false',
    iceServers: [{ urls: env.VITE_STUN_URL ?? 'stun:stun.l.google.com:19302' }],
  };
}

function parsePort(value: string): number {
  const port = Number(value);
  if (!Number.isInteger(port) || port < 1 || port > 65_535) {
    throw new Error('VITE_PEER_PORT must be an integer from 1 to 65535');
  }
  return port;
}
